import { render } from "./GameView.vue?vue&type=template&id=f26db42a&scoped=true"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=f26db42a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26db42a"]])

export default __exports__